import type { MutableRefObject } from 'react';
import React from 'react';

import { useDeliveryFAQs } from 'src/components/molecules/DeliveryFAQs/useDeliveryFAQs';
import { useDeliveryInfo } from 'src/components/molecules/DeliveryInfo/useDeliveryInfo';
import { useDeliveryBlock } from 'src/components/organisms/DeliveryBlock/useDeliveryBlock';
import { DeliveryDrawerView } from './DeliveryDrawerView';
import { useDeliveryDrawer } from './useDeliveryDrawer';

export interface DeliveryDrawerProps {
  target: MutableRefObject<HTMLDivElement | null>;
}

/**
 * Binds the drawer's redux state to its presentational view.
 *
 * The hooks are called here rather than in PDPLayout so that the whole subtree stays behind the
 * layout's `delivery_drawer` dynamic import. Composing them a level up would pull it all into the
 * main PDP bundle.
 */
export const DeliveryDrawer = ({ target }: DeliveryDrawerProps) => {
  const { isOpen, onClose } = useDeliveryDrawer();
  const deliveryBlock = useDeliveryBlock();
  const deliveryFAQs = useDeliveryFAQs();
  const deliveryInfo = useDeliveryInfo();

  return (
    <DeliveryDrawerView
      deliveryBlock={deliveryBlock}
      deliveryFAQs={deliveryFAQs}
      deliveryInfo={deliveryInfo}
      isOpen={isOpen}
      onClose={onClose}
      target={target}
    />
  );
};
